import { Component, OnInit } from '@angular/core';
import { AppLoadingService } from '../../core/services/app-loading.service';

@Component({
  selector: 'lib-privacy-policy-public',
  templateUrl: './privacy-policy-public.component.html',
  styleUrls: ['./privacy-policy-public.component.css'],
})
export class PrivacyPolicyPublicComponent implements OnInit {
  constructor(private appLoadingService: AppLoadingService) {}

  public ngOnInit(): void {
    this.appLoadingService.setFullScreenLoadingAsync(false);
  }
}
